import { Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { TableColumn } from '@nagel-types';

@Component({
    selector: 'lib-column-control',
    imports: [
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatSidenavModule,
        MatListModule,
        MatCheckboxModule,
        FormsModule
    ],
    templateUrl: './column-control.component.html',
    styleUrl: './column-control.component.scss'
})
export class ColumnControlComponent {
    columns = input<TableColumn[]>([]);

    visibilityChange = output<string>();

    onVisibilityChange(columnDef: string): void {
        this.visibilityChange.emit(columnDef);
    }
}